import { useParams, useSearchParams } from 'react-router-dom';
import AddAdvertContainer from 'modules/adverts/containers/AddAdvertContainer';
import NotFoundContainer from 'modules/general/containers/NotFoundContainer';

const AddAdvertView = () => {
  const [searchParams] = useSearchParams();

  const { id: advertKey } = useParams();
  const campaignKey = searchParams.get('campaignKey');

  if (advertKey || campaignKey) return <AddAdvertContainer />;
  return <NotFoundContainer />;
};

export default AddAdvertView;
